// @flow
import React from "react";
import { Button } from "react-bootstrap";
import { Resources } from "../../resources";

class SectionContactUs extends React.Component {
  render() {
    return (
      <div
        id="contact"
        style={{
          minHeight: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative"
        }}
      >
        <div
          style={{
            backgroundImage: 'url("/contact_us_cover_image.jpg")',
            backgroundSize: "cover",
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: "-1"
          }}
        />
        <div>
          <h2>{"For Quotes \u0026 Consultation"}</h2>
          <Button bsStyle="info" href="tel: 1 (647) 862-2009">Call Now: {Resources.phoneNumber}</Button>
        </div>
      </div>
    );
  }
}

export default SectionContactUs;



// WEBPACK FOOTER //
// ./src/pages/home/SectionContactUs.js